import { render, staticRenderFns } from "./LogAction.vue?vue&type=template&id=18bf3451&"
import script from "./LogAction.vue?vue&type=script&lang=js&"
export * from "./LogAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports